/**
 * Generated bundle index. Do not edit.
 */

export {SimpleIconToggleModule} from './public_api';

export {SimpleIconToggleComponent as ɵa} from './src/app/modules/simple-icon-toggle/simple-icon-toggle.component';